<div class="toast-container">
  @if (toast()) {
    <div
      class="toast"
      [ngClass]="toast()?.type"
      [class.until-dismissed]="toast()?.untilDismissed"
      [attr.role]="toast()?.type === 'error' ? 'alert' : 'status'"
      (click)="close()"
    >
      {{ toast()?.message }}
      @if (toast()?.untilDismissed) {
        <button type="button" class="toast-dismiss" aria-label="Dismiss" (click)="close()">&times;</button>
      }
    </div>
  }
</div>
